import { route } from '@md/routing'
import { accessPermission } from '@md/users/permissions'
import { TYPES } from '@md/users/constances'

const List = () => import('./views/List')
const Display = () => import('./views/Display')
const Create = () => import('./views/Create')

const ROUTE_NAME = 'profile:repair:'

const p = name => ROUTE_NAME + name

const LIST = p('list')
const DISPLAY = p('display')
const CREATE = p('create')

export function createRoutes(options) {
  return [
    route('list/', List, LIST, {
      meta: {
        label: 'REPAIR_LIST',
        accessConfig: accessPermission([TYPES.PARTNER, TYPES.DEALER], options),
      },
    }),
    route(':id/detail/', Display, DISPLAY, {
      meta: {
        label: 'REPAIR_DETAIL',
        accessConfig: accessPermission([TYPES.PARTNER, TYPES.DEALER], options),
      },
      props: true,
    }),
    route('create/', Create, CREATE, {
      meta: {
        label: 'REPAIR_CREATE',
        accessConfig: accessPermission([TYPES.PARTNER, TYPES.DEALER], options),
      },
    }),
  ]
}
